import { exportQuestionsFromLib } from "./exportQuestions";
import importQuestions from "./importQuestions";
import stringify from "json-stable-stringify";

export default function importExportTest(serverObj) {
  const serverQL = serverObj.interaction;
  console.log("******************************************");
  console.log("importExportTest");
  console.log("server questionlist:");
  console.log(serverQL);
  console.log(stringify(serverQL));
  console.log("exported questionlist:");
  const { questions, details, description } = importQuestions(serverQL);
  const exportedQL = exportQuestionsFromLib(questions, details);
  console.log(exportedQL);
  console.log(stringify(exportedQL));

  if (stringify(serverQL) === stringify(exportedQL)) {
    console.log("Questionlists are the same");
  } else {
    console.log("Questionlists are different");
  }
  console.log("******************************************");
}
